export default "__VITE_ASSET__ooKWtOP1__"